
<body class="custom-cursor locked">
  <!-- preloader Start -->
  <div id="preloader">
    <div class="loaderr">
          <video autoplay loop muted playsinline width="100px">
            <source src="../../assets/index/img/loader_mf.webm" type="video/webm" />
          </video>
    </div>
  </div>
  <!-- preloader End -->

  <!-- cursor style  -->
  <div class="custom-cursor__cursor"></div>
  <div class="custom-cursor__cursor-two"></div>

  <!-- Main Wrapper Start -->
  <div id="scroll-container">

    <!-- HEADER MENU START -->
    <header class="header">
      <div class="container-fluid">
        <div class="header-bg" >
          <nav class="navigation d-flex align-items-center justify-content-between" style="z-index: 1 !important;">
            <a href="../index" class="d-flex align-items-center link_logo">
              <img src="../../assets/img/suivitim_img/logo_arrondi.webp" alt="/logo" class="logo_navbar" style="max-width: 1%;"
                width="149" height="84" >
            </a>
            <div class="menu-button-right">
              <div class="main-menu__nav">
                <ul class="main-menu__list">
                  <li>
                    <a href="../index" routerLink="../index" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="index_link link_menu">Accueil</a>
                  </li>
                  <li>
                    <a href="../index" routerLink="../index" (click)="scrollToSection('why-choose-sec')" class="why_masterfield link_menu">Pourquoi Masterfield ?</a>
                  </li>
                  <li>
                    <a href="../index" routerLink="../index" (click)="scrollToSection('advantages')" class="avantages link_menu">Avantages</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" routerLink="functionalities" routerLinkActive="active" 
                      class="link_menu" [routerLinkActiveOptions]="{ exact: true }">Fonctionnalités</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" (click)="scrollToSection('qAnda')" class="questions link_menu" id="qa">Q&A</a>
                  </li>
                  <li>
                    <a href="../contact" routerLink="contact" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="link_menu">Contactez-Nous</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="main-menu__right">
              <div class="search-heart-icon d-sm-flex d-none align-items-center gap-24">
                <a class="cus-btn" href="../signin" routerLink="signin" routerLinkActive="active" 
                [routerLinkActiveOptions]="{ exact: true }" *ngIf="!logged">
                  <div class="">
                    <p class="button-text">Se connecter</p>
                  </div>
                  <div class="cus-btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                      viewBox="0 0 16 16" fill="none">
                      <path
                        d="M4.01287 1.38251L4.08491 2.55217L13.1794 1.99206L0.514628 14.6568L1.34327 15.4855L14.008 2.8207L13.4479 11.9152L14.6176 11.9872L15.2855 1.14339L14.8567 0.714656L4.01287 1.38251Z"
                        fill="#008080" />
                    </svg></div>
                </a>
                <a class="cus-btn" href="/index" *ngIf="logged" (click)="disconnect()">
                  <div class="">
                    <p class="button-text">Se déconnecter</p>
                  </div>
                  <div class="cus-btn-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                      viewBox="0 0 16 16" fill="none">
                      <path
                        d="M4.01287 1.38251L4.08491 2.55217L13.1794 1.99206L0.514628 14.6568L1.34327 15.4855L14.008 2.8207L13.4479 11.9152L14.6176 11.9872L15.2855 1.14339L14.8567 0.714656L4.01287 1.38251Z"
                        fill="#008080" />
                    </svg></div>
                </a>
              </div>
              <button class="d-xl-none d-flex main-menu__toggler mobile-nav__toggler">
                <img src="../../assets/index/img/icons/menu-2.png" alt="master field mobile rubriques" loading="lazy">
              </button>
            </div>
          </nav>
        </div>
      </div>
    </header>
    <!-- HEADER MENU END -->
    <router-outlet></router-outlet>
    <!-- FOOTER START -->
    <footer class="footer pt-40 wow fadeInUp" data-wow-delay="400ms">
      <div class="container-fluid" style="padding: unset !important;">
        <div class="footer-wrapper wow fadeInUp" data-wow-delay="400ms" style="border-radius: unset !important;">
          <div class="row row-gap-4 align-items-center">
            <div class="col-lg-6 row">
                <div class="col-lg-6">
                  <img src="../../assets/img/suivitim_img/logo_arrondi.webp" alt="master field - keep it clear" 
                    style="opacity: 0.1;" loading="lazy" *ngIf="!mobile">
                  <img src="../../assets/img/suivitim_img/logo_arrondi.webp" alt="master field - keep it clear" 
                    style="opacity: 0.1;max-width: 40% !important;" loading="lazy" class="pb-3" *ngIf="mobile">
                </div>
                <div class="col-lg-6" [ngClass]="{'pb-3': mobile}">
                  MasterField révolutionne la gestion commerciale sur le terrain. Notre solution optimise 
                  la planification des visites clients, le suivi des performances et la gestion des contacts 
                  en un seul outil intuitif. Maîtrisez l'activité de votre équipe commerciale et simplifiez 
                  votre quotidien pour une efficacité maximale et des décisions stratégiques éclairées.
                </div>
            </div>
            <div class="col-lg-6">
              <div class="footer-block-1">
                <div class="row row-gap-4 align-items-center">
                  <div class="col-sm-6">
                    <div class="footer-adresse">
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
                          <g clip-path="url(#clip0_11651_1501)">
                            <path
                              d="M24.0915 4.25051C23.5731 4.24676 23.1503 4.66395 23.1465 5.18145C23.1428 5.69895 23.559 6.12177 24.0774 6.12552C24.5949 6.12927 25.0178 5.71302 25.0215 5.19552C25.0253 4.67801 24.609 4.2552 24.0915 4.25051Z"
                              fill="#008080" />
                            <path
                              d="M24.0493 9.87541C20.4295 9.84972 17.4651 12.7699 17.4377 16.3886C17.4104 20.0071 20.3322 22.973 23.9509 23.0003C23.9677 23.0003 23.9844 23.0004 24.0011 23.0004C27.5967 23.0004 30.5353 20.0889 30.5625 16.4871C30.5898 12.8688 27.6681 9.90269 24.0493 9.87541ZM24.001 21.1255C23.9891 21.1255 23.9768 21.1254 23.965 21.1253C21.3802 21.1058 19.2931 18.9873 19.3126 16.4027C19.332 13.8297 21.4309 11.7501 23.9993 11.7501C24.0111 11.7501 24.0235 11.7502 24.0353 11.7503C26.6201 11.7698 28.7071 13.8884 28.6876 16.473C28.6681 19.046 26.5693 21.1255 24.001 21.1255Z"
                              fill="#008080" />
                            <path
                              d="M28.0909 4.96138C27.6032 4.78832 27.067 5.04379 26.894 5.53185C26.721 6.01991 26.9765 6.5557 27.4644 6.72876C31.5938 8.19229 34.3459 12.1252 34.3129 16.5152C34.309 17.0329 34.7256 17.4558 35.2433 17.4598C35.2457 17.4598 35.2481 17.4598 35.2506 17.4598C35.7649 17.4598 36.1839 17.0447 36.1879 16.5293C36.2269 11.3405 32.9729 6.69173 28.0909 4.96138Z"
                              fill="#008080" />
                            <path
                              d="M29.7526 35.7915C35.9882 27.7651 39.8851 23.5796 39.9377 16.5573C40.0037 7.72205 32.8335 0.5 23.9989 0.5C15.2674 0.5 8.12941 7.57139 8.06304 16.3183C8.00941 23.531 11.9787 27.7107 18.2573 35.7902C12.0112 36.7236 8.06304 39.0689 8.06304 41.9376C8.06304 43.8592 9.83923 45.5835 13.0645 46.7929C16.0001 47.8937 19.8839 48.5 24.0004 48.5C28.1169 48.5 32.0006 47.8937 34.9362 46.7929C38.1615 45.5834 39.9377 43.8591 39.9377 41.9375C39.9377 39.0704 35.9932 36.7256 29.7526 35.7915ZM9.93795 16.3324C9.99645 8.61408 16.2941 2.375 23.9991 2.375C31.7952 2.375 38.1209 8.74889 38.0628 16.5434C38.0129 23.2122 33.8802 27.3219 27.2824 35.9229C26.1055 37.4562 25.0248 38.906 24.0018 40.3241C22.9818 38.9051 21.9226 37.4814 20.7281 35.9223C13.8575 26.9613 9.88713 23.1621 9.93795 16.3324ZM24.0004 46.6251C15.9518 46.6251 9.93795 44.1504 9.93795 41.9376C9.93795 40.2966 13.5331 38.2236 19.5779 37.5057C20.9141 39.2589 22.0856 40.8518 23.2346 42.4785C23.4101 42.727 23.6953 42.8749 23.9995 42.8751C23.9998 42.8751 24.0001 42.8751 24.0004 42.8751C24.3043 42.8751 24.5894 42.7277 24.7652 42.4797C25.9033 40.8742 27.1069 39.2421 28.4317 37.5068C34.4709 38.2254 38.0628 40.2977 38.0628 41.9377C38.0627 44.1504 32.0489 46.6251 24.0004 46.6251Z"
                              fill="#008080" />
                          </g>
                          <defs>
                            <clipPath>
                              <rect width="48" height="48" fill="white" transform="translate(0 0.5)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div>
                        <p>339 Ibrahim Roudani, Berrechid, Maroc <br>
                          (05)22 226-603</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="footer-adresse">
                      <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
                          <g clip-path="url(#clip0_11651_1501)">
                            <path
                              d="M24.0915 4.25051C23.5731 4.24676 23.1503 4.66395 23.1465 5.18145C23.1428 5.69895 23.559 6.12177 24.0774 6.12552C24.5949 6.12927 25.0178 5.71302 25.0215 5.19552C25.0253 4.67801 24.609 4.2552 24.0915 4.25051Z"
                              fill="#008080" />
                            <path
                              d="M24.0493 9.87541C20.4295 9.84972 17.4651 12.7699 17.4377 16.3886C17.4104 20.0071 20.3322 22.973 23.9509 23.0003C23.9677 23.0003 23.9844 23.0004 24.0011 23.0004C27.5967 23.0004 30.5353 20.0889 30.5625 16.4871C30.5898 12.8688 27.6681 9.90269 24.0493 9.87541ZM24.001 21.1255C23.9891 21.1255 23.9768 21.1254 23.965 21.1253C21.3802 21.1058 19.2931 18.9873 19.3126 16.4027C19.332 13.8297 21.4309 11.7501 23.9993 11.7501C24.0111 11.7501 24.0235 11.7502 24.0353 11.7503C26.6201 11.7698 28.7071 13.8884 28.6876 16.473C28.6681 19.046 26.5693 21.1255 24.001 21.1255Z"
                              fill="#008080" />
                            <path
                              d="M28.0909 4.96138C27.6032 4.78832 27.067 5.04379 26.894 5.53185C26.721 6.01991 26.9765 6.5557 27.4644 6.72876C31.5938 8.19229 34.3459 12.1252 34.3129 16.5152C34.309 17.0329 34.7256 17.4558 35.2433 17.4598C35.2457 17.4598 35.2481 17.4598 35.2506 17.4598C35.7649 17.4598 36.1839 17.0447 36.1879 16.5293C36.2269 11.3405 32.9729 6.69173 28.0909 4.96138Z"
                              fill="#008080" />
                            <path
                              d="M29.7526 35.7915C35.9882 27.7651 39.8851 23.5796 39.9377 16.5573C40.0037 7.72205 32.8335 0.5 23.9989 0.5C15.2674 0.5 8.12941 7.57139 8.06304 16.3183C8.00941 23.531 11.9787 27.7107 18.2573 35.7902C12.0112 36.7236 8.06304 39.0689 8.06304 41.9376C8.06304 43.8592 9.83923 45.5835 13.0645 46.7929C16.0001 47.8937 19.8839 48.5 24.0004 48.5C28.1169 48.5 32.0006 47.8937 34.9362 46.7929C38.1615 45.5834 39.9377 43.8591 39.9377 41.9375C39.9377 39.0704 35.9932 36.7256 29.7526 35.7915ZM9.93795 16.3324C9.99645 8.61408 16.2941 2.375 23.9991 2.375C31.7952 2.375 38.1209 8.74889 38.0628 16.5434C38.0129 23.2122 33.8802 27.3219 27.2824 35.9229C26.1055 37.4562 25.0248 38.906 24.0018 40.3241C22.9818 38.9051 21.9226 37.4814 20.7281 35.9223C13.8575 26.9613 9.88713 23.1621 9.93795 16.3324ZM24.0004 46.6251C15.9518 46.6251 9.93795 44.1504 9.93795 41.9376C9.93795 40.2966 13.5331 38.2236 19.5779 37.5057C20.9141 39.2589 22.0856 40.8518 23.2346 42.4785C23.4101 42.727 23.6953 42.8749 23.9995 42.8751C23.9998 42.8751 24.0001 42.8751 24.0004 42.8751C24.3043 42.8751 24.5894 42.7277 24.7652 42.4797C25.9033 40.8742 27.1069 39.2421 28.4317 37.5068C34.4709 38.2254 38.0628 40.2977 38.0628 41.9377C38.0627 44.1504 32.0489 46.6251 24.0004 46.6251Z"
                              fill="#008080" />
                          </g>
                          <defs>
                            <clipPath>
                              <rect width="48" height="48" fill="white" transform="translate(0 0.5)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div>
                        <p>21 Boulevard Zerktouni <br> Casablanca, Maroc</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-gap-4 align-items-center" *ngIf="!mobile">
                <div class="col-6">
                  <ul class="foorer-links">
                    <li>
                      <a href="../index" routerLink="../index" routerLinkActive="active" class="hover-content mb-4p link_footer">Accueil</a></li>
                    <li>
                      <a href="#why-choose-sec" (click)="scrollToSection('why-choose-sec')" class="hover-content mb-4p link_footer why_masterfield">Pourquoi Masterfield ?</a>
                    </li>
                    <li>
                      <a href="#advantages"  class="hover-content mb-4p link_footer avantages" (click)="scrollToSection('advantages')" >Avantages</a>
                    </li>
                    <li>
                      <a href="../functionalities"  class="hover-content mb-4p link_footer">Fonctionnalités</a>
                    </li>
                    <li>
                      <a href="#qAnda" (click)="scrollToSection('qAnda')" class="hover-content mb-4p link_footer questions">Q&A</a>
                    </li>
                    <li>
                      <a href="../contact" routerLink="../contact" routerLinkActive="active" class="hover-content mb-4p link_footer">Contactez-Nous</a>
                    </li>
                    <li><a href="../signin" class="hover-content mb-4p link_footer">Se connecter</a></li>
                  </ul>
                </div>
                <div class="col-6">
                  <ul class="foorer-links">
                    <li>
                      <a href="https://www.linkedin.com/showcase/masterfield/" class="hover-content mb-4p link_footer">
                        <i class="fa-brands fa-linkedin mr-3"></i> LinkedIn 
                      </a></li>
                    <li>
                      <a href="https://www.facebook.com/profile.php?id=100083394046450" class="hover-content mb-4p link_footer">
                        <i class="fa-brands fa-facebook-f mr-3"></i>Facebook</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="circle_vector-2"></div>
              <div class="circle_vector-3"></div>
            </div>
          </div>
          <div class="row text-center mt-3 d-block">
            <p class="copyright">© Copyrights {{ currentYear }} - Tous les droits sont réservés</p>
          </div>
        </div>
      </div>
      <!-- <div class="scrollTop text-right"><i class="flaticon-up-arrow-fill-1"></i></div> -->
    </footer>
    <!-- FOOTER END -->

    <!-- Main Wrapper End -->
  </div>

  <!-- back-to-top-start -->
  <a href="javascript:void(0)" class="scrollTop scroll-top">
    <svg class="scroll-top__circle" width="100%" height="100%" viewBox="-1 -1 102 102">
      <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
    </svg>
  </a>
  <!-- back-to-top-end -->
  <!-- Mobile Menu Start -->
  <div class="mobile-nav__wrapper" id="mobile-nav__wrapper">
    <div class="mobile-nav__overlay mobile-nav__toggler"></div>
    <div class="mobile-nav__content">
      <span class="mobile-nav__close mobile-nav__toggler"><i class="fa fa-times"></i></span>
      <div class="logo-box">
        <a href="/index" aria-label="logo image">
          <img src="../../assets/img/suivitim_img/logo_arrondi.webp" alt="keep it clear" 
            style="max-width: 40% !important;opacity: 0.1;" *ngIf="!mobile" loading="lazy">
          <img src="../../assets/img/suivitim_img/logo_arrondi.webp" alt="gérer vos visites avec la solution masterField " loading="lazy">
        </a>
      </div>
      <div class="mobile-nav__container"></div>
      <ul class="foorer-links" *ngIf="!mobile">
        <li>
          <a href="../index" routerLink="../index" routerLinkActive="active" class="hover-content mb-4p link_footer">Accueil</a></li>
        <li>
          <a href="#why-choose-sec" (click)="scrollToSection('why-choose-sec')" class="hover-content mb-4p link_footer">Pourquoi Masterfield ?</a>
        </li>
        <li>
          <a href="#advantages" (click)="scrollToSection('advantages')" class="hover-content mb-4p link_footer" >Avantages</a>
        </li>
        <li class="scrollTop">
          <a href="javascript:void(0)" routerLink="functionalities" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="hover-content mb-4p link_footer">Fonctionnalités</a>
        </li>
        <li>
          <a href="#qAnda" (click)="scrollToSection('qAnda')" class="hover-content mb-4p link_footer questions">Q&A</a>
        </li>
        <li class="scrollTop">
          <a href="javascript:void(0)" routerLink="contact" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="hover-content mb-4p link_footer">Contactez-Nous</a>
        </li>
        <li><a href="../signin" routerLink="signin" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="hover-content mb-4p link_footer">Se connecter</a></li>
      </ul>
        <a href="../signin" routerLink="signin" routerLinkActive="active" 
          [routerLinkActiveOptions]="{ exact: true }" class="mb-3 cus-btn cus-btn-mobile ml-0">Se connecter</a>
      <div class="mobile-nav__social">
        <a href="https://www.linkedin.com/showcase/masterfield/">
          <i class="fa-brands fa-linkedin"></i></a>
        <a href="https://www.facebook.com/profile.php?id=100083394046450">
          <i class="fa-brands fa-facebook-f"></i></a>
      </div>
    </div>
  </div>
  <!-- Mobile Menu End -->
</body>